"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PassengerType;
(function (PassengerType) {
    PassengerType["Child"] = "child";
    PassengerType["Youth"] = "youth";
    PassengerType["Adult"] = "adult";
    PassengerType["Senior"] = "senior";
})(PassengerType || (PassengerType = {}));
exports.default = PassengerType;
